import exports from './exports'
import modal from './modal'

export default {
  modules: {
    exports,
    modal,
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
}
